





























































































































import { Component, Vue, Watch } from "vue-property-decorator";
//@ts-ignore
import moment from "moment";
import PrestadorAutocomplete from "@/components/saude/PrestadorAutocomplete.vue";
import DetalheAgendamentos from "./DetalheAgendamentos.vue";
import GsModalDialog from "@/components/modal/GsModalDialog.vue"
import { PrestadorResumidoModel } from "@/models/cadastros/saude/PrestadorResumidoModel";
import { cadastroPrestadorService } from "@/service/cadastro/saude/CadastroPrestadorService";
import EspecialidadeModel from "@/models/cadastros/saude/EspecialidadeModel";
import { ProfissionalModel } from '@/models/cadastros/saude/ProfissionalModel';
import { cadastroAgendaService } from '@/service/cadastro/saude/agenda/CadastroAgendaService';
import { HorariosDisponiveisDTO } from '@/api/cadastro/saude/HorariosDisponiveisDTO';

@Component({
  components: {
    PrestadorAutocomplete,
    DetalheAgendamentos,
    GsModalDialog
  },
})
export default class VisualizarAgenda extends Vue {
  prestadorSelecionado = {} as PrestadorResumidoModel;

  atendimentoPorEspecialidadeOuProfissional = "ESPECIALIDADE";

  especialidades: Array<EspecialidadeModel | undefined> = [];
  especialidadeSelecionada: EspecialidadeModel = {} as EspecialidadeModel;
  nomeEspecialidade = "";

  profissionais: ProfissionalModel[] = [];
  profissionalSelecionado: ProfissionalModel = {} as ProfissionalModel;
  nomeProfissional = "";

  dateString? = moment().format("DD/MM/YYYY");
  dataAgenda? = moment().format("YYYY-MM-DD");
  menu1 = false;

  exibirResultado = false;
  horariosDisponiveis: HorariosDisponiveisDTO[] = [];

  mensagemBloqueioDesbloqueioModal = false;
  tituloBloqueioDesbloqueioModal = "";
  conteudoBloqueioDesbloqueioModal = "";
  confirmacao = false;
  horarioBloqueioDesbloqueio: HorariosDisponiveisDTO | null = null;

  mounted() {
    this.selecionarTipoAgenda();
  }

  @Watch("prestadorSelecionado")
  obterDadosPrestador(val: PrestadorResumidoModel) {
    this.dataAgenda = undefined;
    this.dateString = undefined;
    if (val && val.id) {
      cadastroPrestadorService.obterPrestador(val.id).then((res) => {
        this.especialidades = res.especialidadesPrestador.map(
          (especialidadePrestador) => {
            return especialidadePrestador.especialidade;
          }
        );
        this.profissionais = res.profissionaisPrestador;
      });
    } else {
      this.selecionarTipoAgenda();
    }
  }

  selecionarProfissional() {
    this.dataAgenda = undefined;
    this.dateString = undefined;
    this.exibirResultado = false;
  }

  selecionarEspecialidade() {
    this.dataAgenda = undefined;
    this.dateString = undefined;
    this.exibirResultado = false;
  }

  selecionarTipoAgenda() {
    this.profissionalSelecionado = {} as ProfissionalModel;
    this.especialidadeSelecionada = {} as EspecialidadeModel;
    this.dataAgenda = undefined;
    this.dateString = undefined;
    this.exibirResultado = false;
  }

  get isDisabledEspecialidadeOuProfissional() {
    return !this.prestadorSelecionado || !this.prestadorSelecionado.id;
  }

  get isApresentarCalendario() {
    return this.profissionalSelecionado.id || this.especialidadeSelecionada.id
  }

  get minDate() {
    return moment().format("YYYY-MM-DD");
  }

  @Watch("dataAgenda")
  formatarData(val: string) {
    if(!val) return null;
    this.dateString = moment(val, "YYYY-MM-DD", true).format("DD/MM/YYYY");
  }

  parseDate(date: string) {
    if (!date) return null;
    return moment(date, "DD/MM/YYYY", true).format("YYYY-MM-DD");
  }
  
  selectDate() {
    this.menu1 = false;
    this.obterAgenda();
  }

  obterAgenda() {
    if(this.atendimentoPorEspecialidadeOuProfissional == "ESPECIALIDADE") {
      cadastroAgendaService.obterAgendaPrestadorEspecialidade(
        this.prestadorSelecionado.id,
        this.especialidadeSelecionada.id || -1,
        this.dataAgenda || moment().format("YYYY-MM-DD")
      )
      .then(res => {
        this.horariosDisponiveis = res;
        this.exibirResultado = true;
      });
    } else {
      cadastroAgendaService.obterAgendaProfissional(
        this.profissionalSelecionado.id || -1,
        this.dataAgenda || moment().format("YYYY-MM-DD")
      )
      .then(res => {
        this.horariosDisponiveis = res;
        this.exibirResultado = true;
      });
    }
  }

  cancelarBloqueio() {
    this.mensagemBloqueioDesbloqueioModal = false;
    this.tituloBloqueioDesbloqueioModal = "";
    this.conteudoBloqueioDesbloqueioModal = "";
    this.confirmacao = false;
    this.horarioBloqueioDesbloqueio = null;
  }

  confirmarBloqueio() {
    if (this.atendimentoPorEspecialidadeOuProfissional == "ESPECIALIDADE") {
      cadastroAgendaService.bloquearAgendaPrestador(
        this.prestadorSelecionado.id,
        this.especialidadeSelecionada.id || -1,
        this.dataAgenda || "",
        this.horarioBloqueioDesbloqueio?.horarioInicio || ""
      )
      .then(() => {
        this.tituloBloqueioDesbloqueioModal = "Sucesso";
        this.conteudoBloqueioDesbloqueioModal = "Bloqueio de agenda efetuado com sucesso";
        this.confirmacao = false;
        this.mensagemBloqueioDesbloqueioModal = true;
      })
      .catch(err => {
        this.tituloBloqueioDesbloqueioModal = "Erro";
        this.conteudoBloqueioDesbloqueioModal = err.message;
        this.confirmacao = false;
        this.mensagemBloqueioDesbloqueioModal = true;
      });
    } else {
      cadastroAgendaService.bloquearAgendaProfissional(
        this.profissionalSelecionado.id || -1,
        this.dataAgenda || "",
        this.horarioBloqueioDesbloqueio?.horarioInicio || ""
      )
      .then(() => {
        this.tituloBloqueioDesbloqueioModal = "Sucesso";
        this.conteudoBloqueioDesbloqueioModal = "Bloqueio de agenda efetuado com sucesso";
        this.confirmacao = false;
        this.mensagemBloqueioDesbloqueioModal = true;
      })
      .catch(err => {
        this.tituloBloqueioDesbloqueioModal = "Erro";
        this.conteudoBloqueioDesbloqueioModal = err.message;
        this.confirmacao = false;
        this.mensagemBloqueioDesbloqueioModal = true;
      });
    }
  }

  bloquearHorario(horario: HorariosDisponiveisDTO) {
    this.horarioBloqueioDesbloqueio = horario;
    this.tituloBloqueioDesbloqueioModal = "Confirma?";
    if (horario.status === "AGENDADO") {
      this.conteudoBloqueioDesbloqueioModal = "Existem atendimentos agendados, ao bloquear a agenda os agendamentos serão desmarcados automaticamente. Deseja seguir com o bloqueio?";   
    } else {
      this.conteudoBloqueioDesbloqueioModal = "Deseja seguir com o bloqueio?";
    }
    this.confirmacao = true;
    this.mensagemBloqueioDesbloqueioModal = true;
  }
  
  desbloquearHorario(horario: HorariosDisponiveisDTO) {
    if (this.atendimentoPorEspecialidadeOuProfissional == "ESPECIALIDADE") {
      cadastroAgendaService.desbloquearAgendaPrestador(
        this.prestadorSelecionado.id,
        this.especialidadeSelecionada.id || -1,
        this.dataAgenda || "",
        horario.horarioInicio
      )
      .then(() => {
        this.tituloBloqueioDesbloqueioModal = "Sucesso";
        this.conteudoBloqueioDesbloqueioModal = "Desbloqueio de agenda efetuado com sucesso";
        this.confirmacao = false;
        this.mensagemBloqueioDesbloqueioModal = true;
      })
      .catch(err => {
        this.tituloBloqueioDesbloqueioModal = "Erro";
        this.conteudoBloqueioDesbloqueioModal = err.message;
        this.confirmacao = false;
        this.mensagemBloqueioDesbloqueioModal = true;
      });
    } else {
      cadastroAgendaService.desbloquearAgendaProfissional(
        this.profissionalSelecionado.id || -1,
        this.dataAgenda || "",
        horario.horarioInicio
      )
      .then(() => {
        this.tituloBloqueioDesbloqueioModal = "Sucesso";
        this.conteudoBloqueioDesbloqueioModal = "Desbloqueio de agenda efetuado com sucesso";
        this.confirmacao = false;
        this.mensagemBloqueioDesbloqueioModal = true;
      })
      .catch(err => {
        this.tituloBloqueioDesbloqueioModal = "Erro";
        this.conteudoBloqueioDesbloqueioModal = err.message;
        this.confirmacao = false;
        this.mensagemBloqueioDesbloqueioModal = true;
      });
    }
  }

  fecharModal() {
    this.cancelarBloqueio();
    this.obterAgenda();
  }
}
